import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { authAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "../Common/IsLoadingHOC";
import { setReportFormatDate, showLimitedText } from "../Helper/helper";
import { useSelector } from "react-redux";
import DeleteConfirmationModel from "./Models/DeleteConfirmationModel";
import AddHealthCenter from "./Models/AddHealthCenter";
import { FiPlus } from "react-icons/fi";
import Pagination from "../Common/Pagination";
import { IoMdMore } from "react-icons/io";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import AddDoctors from "./Models/AddDoctors";
import { useTranslation } from "react-i18next";
import IsLoggedinHOC from "../Common/IsLoggedInHOC";

const Doctors = (props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { setLoading } = props;
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(5);
  const [totalPosts, setTotalPosts] = useState(5);

  const [allmodel, setallmodel] = useState({
    data: [],
    showDeleteModel: false,
    showHealthCenterModel: false,
  });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const currentLanguage = i18next.language;

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await authAxios().get(
        `/admin/doctors?page=${currentPage}&limit=${postsPerPage}`
      );
      setLoading(false);
      console.log("dfdfs", response?.data.data)
      setData(response?.data.data.doctors);
      setTotalPosts(response.data.data.totalDoctors)
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleCancel = () => {
    setallmodel((prev) => ({
      ...prev,
      data: [],
      showDeleteModel: false,
      showHealthCenterModel: false,
    }));
  };

  const handleDelete = async () => {
    await authAxios()
      .delete(`/admin/doctors/${allmodel.data._id}`)
      .then((response) => {
        handleCancel();
        toast.success(response.data.message);
        fetchAllData();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const handleAdd = async (data) => {
    const payload = data
    await authAxios()
      .post(`/admin/doctors`, payload)
      .then((response) => {
        console.log("res", response)
        fetchAllData()
        handleCancel()
      }).catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      })
  }

  const handleUpdate = async (data) => {
    console.log("asdasd", allmodel)
    const payload = data
    await authAxios()
      .put(`/admin/doctors/${allmodel?.data?._id}`, payload)
      .then((response) => {
        console.log("res", response)
        fetchAllData()
        handleCancel()
      }).catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      })
  }

  useEffect(() => {
    fetchAllData();
  }, [currentPage]);

  return (
    <>
      <div className="px-[50px] py-[20px] bg-lightgray area--page pb-0">
        <div className="w-[100%] mx-auto pb-[65px]">
          {/* <div className="flex mb-[30px] gap-[20px] items-center">
            <h1 className="text-[clamp(20px,2vw,35px)] leading-none font-semibold">Doctors</h1>
          </div> */}

          <div className="flex mb-[30px] gap-[20px] gap-y-[10px] md:items-center w-full md:justify-between md:flex-row flex-col-reverse">
            <div className="flex gap-[5px] gap-y-[10px] flex-wrap w-full justify-end">
              <button className="flex items-center max-w-[140px] border border-white w-full justify-center bg-white text-textcolor py-[8px] px-[10px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:border-textcolor hover:text-textcolor h-[45px] font-[600] min-h">
                Total : {totalPosts || 0}
              </button>

              <button
                onClick={() => setallmodel((prev) => ({
                  ...prev,
                  data: [],
                  showHealthCenterModel: true,
                }))}
                className="flex items-center max-w-[160px] border border-buttonbg w-full justify-center bg-buttonbg text-white py-[8px] px-[15px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:text-textcolor h-[45px] font-[600] min-h"
              >
                <FiPlus />
                Add
              </button>
            </div>
          </div>

          <div className="relative mt-[10px] overflow-x-auto px-[20px] py-[15px] bg-white rounded-t-[10px] h-[100vh] over--scroller area--table">
            <table className="w-full text-sm text-left text-gray-500 ">
              <thead className="text-xs text-lightcolor border-b border-textcolor">
                <tr>
                  <th className="p-4 font-[400]">S.no</th>
                  <th className="p-4 font-[400]">Image</th>
                  <th className="p-4 font-[400]">Name</th>
                  <th className="p-4 font-[400]">About</th>
                  <th className="p-4 font-[400]">Department</th>
                  <th className="p-4 font-[400]">Address</th>
                  <th className="p-4 font-[400]">Contact</th>
                  <th className="p-4 font-[400]">Email</th>
                  <th className="p-4 font-[400]">Social Links</th>
                  <th className="p-2 font-[400] w-[50px]">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.map((item, index) => (
                    <tr key={index} className="bg-white border-b hover:bg-gray-50">
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="whitespace-no-wrap text-textcolor">{index + 1}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <img className="w-[40px] h-[40px] rounded-full" src={`${process.env.REACT_APP_IMAGE_URL}/${item?.image}`} alt="Doctor" />
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.name[currentLanguage]}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        {/* <p className="text-gray-900 whitespace-no-wrap">{item.about[currentLanguage]}</p> */}

                        <div class='has-tooltip'>
                          <span class='tooltip rounded shadow-lg p-1 bg-gray-100 text-black -mt-8'> {item?.about[currentLanguage]}</span>
                          {
                            showLimitedText(item?.about[currentLanguage])
                          }
                        </div>

                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item?.department?.name[currentLanguage] || "N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.address[currentLanguage] || "N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.contactNumberOne || "N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <p className="text-gray-900 whitespace-no-wrap">{item.email || "N/A"}</p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm">
                        <div className="flex gap-2">
                          {!(item?.facebook || item?.instagram || item?.twitter || item?.youtube||item?.linkedin ||item?.website) ? (
                            <>N/A</>
                          ) : (
                            <>
                              {item?.facebook && (
                                <a href={item.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-600">
                                  FB
                                </a>
                              )}
                              {item?.instagram && (
                                <a href={item.instagram} target="_blank" rel="noopener noreferrer" className="text-pink-600">
                                  IG
                                </a>
                              )}
                              {item?.twitter && (
                                <a href={item.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-400">
                                  TW
                                </a>
                              )}
                              {item?.youtube && (
                                <a href={item.youtube} target="_blank" rel="noopener noreferrer" className="text-red-600">
                                  YT
                                </a>
                              )}
                              {item?.linkedin && (
                                <a href={item.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600">
                                  LI
                                </a>
                              )}
                               {item?.website && (
                                <a href={item.website} target="_blank" rel="noopener noreferrer" className="text-blue-600">
                                  WB
                                </a>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td className="p-2 border-b border-gray-200 text-sm">
                        <Menu as="div" className="relative inline-block text-left">
                          <Menu.Button className="more--icon cursor-pointer w-[30px] h-[30px] bg-lightgray rounded-[5px] flex items-center justify-center">
                            <IoMdMore />
                          </Menu.Button>
                          <Menu.Items className={`absolute ${isRTL ? "left-0" : "right-0"} z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5`}>
                            <div className="py-1" onClick={() => setallmodel((prev) => ({
                              ...prev,
                              data: item,
                              showHealthCenterModel: true
                            }))} >
                              <Menu.Item>
                                {({ active }) => (
                                  <a className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"}`}>
                                    Edit
                                  </a>
                                )}
                              </Menu.Item>
                            </div>

                            <div onClick={() => setallmodel((prev) => ({
                              ...prev,
                              data: item,
                              showDeleteModel: true
                            }))} className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <a className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"}`}>
                                    Delete
                                  </a>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Menu>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPosts={totalPosts}
            paginate={paginate}
            postsPerPage={postsPerPage}
            length={data?.length}
          />

          {allmodel.showDeleteModel && (
            <DeleteConfirmationModel handleCancel={handleCancel} handleDelete={handleDelete} />
          )}
          {allmodel.showHealthCenterModel && (
            <AddDoctors handleCancel={handleCancel} handleAdd={handleAdd} handleUpdate={handleUpdate} allmodel={allmodel} />
          )}
        </div>
      </div>
    </>
  );
};

export default IsLoggedinHOC(IsLoadingHOC(Doctors));
